import React from 'react'
import "./Numbers.css"
import { TfiLayoutLineSolid } from "react-icons/tfi";

const Numbers = () => {
    return (
        <div className='no-main'>
            <div className="no-container">
                <div className="no-top">
                    <div className="no-head">
                        <span><TfiLayoutLineSolid />Compliance & Trust
                        </span>
                    </div>
                    <div className="no-text">
                        <span>The fine print, in plain sight.
                        </span>
                    </div>
                    <div className="no-p">
                        <p>Required regulatory information for a Motilal Oswal Business Associate. Fields marked in italics need the client's real registration details before this goes live.</p>
                    </div>
                </div>
                <div className="no-bottom">
                    <div className="no-grid">
                        <div className="grid-1">
                            <div className="grid-head">
                                <span>SEBI Registration</span>
                            </div>
                            <div className="grid-text">
                                <span>Trades executed via Motilal Oswal Financial Services Ltd.</span>
                            </div>
                            <div className="grid-end">
                                <span>Associate Reg. No.: [INZ000158836]</span>
                            </div>
                        </div>
                        <div className="grid-1">
                            <div className="grid-head">
                                <span>Exchange Membership</span>
                            </div>
                            <div className="grid-text">
                                <span>NSE / BSE Member (via MOFSL)</span>
                            </div>
                            <div className="grid-end">
                                <span>Member ID: [AP0297608421]</span>
                            </div>
                        </div>
                        <div className="grid-1">
                            <div className="grid-head">
                                <span>Investor Grievances</span>
                            </div>
                            <div className="grid-text">
                                <span>For unresolved complaints, use the SEBI SCORES portal or MOFSL's grievance desk: [ 96465 55699]</span>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="no-line" />

                <div className="no-end">
                    <p>Investments in securities markets are subject to market risks. Read all scheme-related and offer documents carefully before investing. Registration granted by SEBI, membership of BSE/NSE and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.</p>
                </div>
            </div>
        </div>
    )
}

export default Numbers